import { render, staticRenderFns } from "./files.vue?vue&type=template&id=279caa7a&scoped=true&"
import script from "./files.vue?vue&type=script&lang=ts&"
export * from "./files.vue?vue&type=script&lang=ts&"
import style0 from "./files.vue?vue&type=style&index=0&id=279caa7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279caa7a",
  null
  
)

export default component.exports